import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../context/AuthContext';
import LanguageSelector from '../common/LanguageSelector';

const navItems = [
  { path: '/', labelKey: 'navigation.home', end: true },
  { path: '/workout-plans', labelKey: 'navigation.workoutPlans' },
  { path: '/diet-plans', labelKey: 'navigation.dietPlans' },
  { path: '/progress', labelKey: 'navigation.progress' },
  { path: '/ai-assistant', labelKey: 'navigation.chatWithAI' },
  { path: '/profile', labelKey: 'navigation.profile' },
];

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
    isActive
      ? 'bg-indigo-100 text-indigo-700'
      : 'text-gray-600 hover:text-indigo-600 hover:bg-gray-50'
  }`;

export default function Navigation() {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="bg-white border-b border-gray-200 shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-14">
          <span className="text-lg font-bold text-indigo-600">Muscle Guide</span>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink key={item.path} to={item.path} end={item.path === '/' || (item as any).end} className={navLinkClass}>
                {t(item.labelKey)}
              </NavLink>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <LanguageSelector />
            <button
              onClick={logout}
              className="hidden md:block px-3 py-1.5 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            >
              {t('navigation.logout')}
            </button>
            {/* Mobile hamburger */}
            <button
              onClick={() => setMenuOpen((prev) => !prev)}
              className="md:hidden p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
              aria-label="Toggle menu"
            >
              {menuOpen ? <XMarkIcon className="w-5 h-5" /> : <Bars3Icon className="w-5 h-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-gray-100 bg-white px-4 py-3 flex flex-col gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/' || (item as any).end}
              className={navLinkClass}
              onClick={() => setMenuOpen(false)}
            >
              {t(item.labelKey)}
            </NavLink>
          ))}
          <button
            onClick={() => { setMenuOpen(false); logout(); }}
            className="mt-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors text-left"
          >
            {t('navigation.logout')}
          </button>
        </div>
      )}
    </nav>
  );
}
